import React from "react";
import SiteConfig from "../../config/SiteConfig.json";
import { Link } from "gatsby";
import { Row, Col } from "reactstrap";
import _ from "lodash";
import Seo from "../components/SEO";
import Layout from "../components/layout";
import { CategoryIcons } from "../../utils/Category-Icons";
import { isChrome, isSafari, isFirefox } from "react-device-detect";
import { graphql, withPrefix } from "gatsby";

class TranslatedIndexPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textIndent: "",
      textMargin: "",
    };
  }

  componentDidMount() {
    if (isChrome) {
      this.setState({ textIndent: "-1.35em", textMargin: "2em" });
    } else if (isFirefox) {
      this.setState({ textIndent: "", textMargin: "1.4em" });
    } else if (isSafari) {
      this.setState({ textIndent: "-1em", textMargin: "1.4em" });
    }
  }

  render() {
    let env = this.props.data.site.siteMetadata.env;

    let { json, lang, popularTopics } = this.props.pageContext;
    let _json = json;
    let _popularTopics = popularTopics
    let { textMargin } = this.state;

    // this part need to be moved to a different file or use api to translate it.
    let categoryTitle, faqAsk, getInT, viewAll, contSup, contCor;
    switch (lang) {
      case "ru":
        categoryTitle = "Категории";
        faqAsk = "Часто задаваемые вопросы";
        getInT = "Связаться";
        contSup = "Контактная поддержка";
        contCor = "Связаться с корпоративным";
        viewAll = "Посмотреть все";
        break;
      case "es":
        categoryTitle = "Categorías";
        faqAsk = "Preguntas frecuentes";
        getInT = "Ponerse en contacto";
        contSup = "Soporte de contacto";
        contCor = "Contacto Corporativo";
        viewAll = "Ver todo";
        break;
      case "it":
        categoryTitle = "Categorie";
        faqAsk = "Richiesto di frequente";
        getInT = "Mettiti in contatto";
        contSup = "Contatta il supporto";
        contCor = "Contatta Azienda";
        viewAll = "Guarda tutto";
        break;
      case "de":
        categoryTitle = "Kategorien";
        faqAsk = "Oft gefragt";
        getInT = "In Kontakt kommen";
        contSup = "Kontaktieren Sie Support";
        contCor = "Wenden Sie sich an Unternehmen";
        viewAll = "Alle ansehen";
        break;
      case "pt":
        categoryTitle = "Categorias";
        faqAsk = "Frequentemente perguntado";
        getInT = "Entrar em contato";
        contSup = "Entre em contato com o suporte";
        contCor = "Contato Corporativo";
        viewAll = "Ver tudo";
        break;
      case "fr":
        categoryTitle = "Catégories";
        faqAsk = "Fréquemment demandé";
        getInT = "Entrer en contact";
        contSup = "Contactez le support";
        contCor = "Contacter l'entreprise";
        viewAll = "Voir tout";
        break;
      case "ja":
        categoryTitle = "カテゴリ";
        faqAsk = "よくある質問";
        getInT = "連絡する";
        contSup = "サポート問い合わせ先";
        contCor = "企業に連絡する";
        viewAll = "すべて見る";
        break;
      case "cs":
        categoryTitle = "Kategorie";
        faqAsk = "Často kladený dotaz";
        getInT = "Být v kontaktu";
        contSup = "Kontaktujte podporu";
        contCor = "Kontaktujte společnost";
        viewAll = "Zobrazit vše";
        break;
      case "id": //indonesia
        categoryTitle = "Kategori";
        faqAsk = "Sering ditanyakan";
        getInT = "Berhubungan";
        contSup = "Hubungi Dukungan";
        contCor = "Hubungi Perusahaan";
        viewAll = "Lihat semua";
        break;
      case "nb": //norvegian
        categoryTitle = "Kategorier";
        faqAsk = "Ofte spurt";
        getInT = "Ta kontakt";
        contSup = "Kontakt kundestøtte";
        contCor = "Kontakt Corporate";
        viewAll = "Se alt";
        break;
      case "hi":
        categoryTitle = "श्रेणियाँ";
        faqAsk = "अक्सर पूछे जाने वाले";
        getInT = "संपर्क में रहो";
        contSup = "सहयोग टीम से संपर्क करें";
        contCor = "कॉर्पोरेट से संपर्क करें";
        viewAll = "सभी को देखें";
        break;
      case "fi":
        categoryTitle = "Luokat";
        faqAsk = "Usein kysyttyä";
        getInT = "Ota yhteyttä";
        contSup = "Ota yhteyttä tukeen";
        contCor = "Ota yhteyttä yritykseen";
        viewAll = "Näytä kaikki";
        break;
      case "ko":
        categoryTitle = "카테고리";
        faqAsk = "자주 묻는 질문";
        getInT = "연락하기";
        contSup = "연락처 지원";
        contCor = "기업에 문의";
        viewAll = "모두보기";
        break;
      case "hu":
        categoryTitle = "Kategóriák";
        faqAsk = "Gyakran kérdezik";
        getInT = "Felveszi a kapcsolatot";
        contSup = "Lépjen kapcsolatba az ügyfélszolgálattal";
        contCor = "Lépjen kapcsolatba a vállalattal";
        viewAll = "Összes megtekintése";
        break;
      case "hr": //croatian
        categoryTitle = "Kategorije";
        faqAsk = "Često pitana";
        getInT = "Javite se";
        contSup = "Obratite se podršci";
        contCor = "Kontaktirajte tvrtku";
        viewAll = "Pogledaj sve";
        break;
      case "el": //greek
        categoryTitle = "Κατηγορίες";
        faqAsk = "Συχνές ερωτήσεις";
        getInT = "Ερχομαι σε επαφή";
        contSup = "Επικοινωνήστε με την υποστήριξη";
        contCor = "Επικοινωνήστε με την εταιρεία";
        viewAll = "Προβολή όλων";
        break;
      case "nl": //dutch
        categoryTitle = "Categorieën";
        faqAsk = "Vaak gevraagd";
        getInT = "Neem contact op";
        contSup = "Contact opnemen met ondersteuning";
        contCor = "Neem contact op met het bedrijf";
        viewAll = "Bekijk alles";
        break;
      case "pl":
        categoryTitle = "Kategorie";
        faqAsk = "Często zadawane";
        getInT = "Skontaktuj się";
        contSup = "Skontaktuj się z pomocą techniczną";
        contCor = "Neem contact op met het bedrijf";
        viewAll = "Pokaż wszystkie";
        break;
      case "tr":
        categoryTitle = "Kategoriler";
        faqAsk = "Sık sorulan";
        getInT = "Temasta olmak";
        contSup = "İletişim desteği";
        contCor = "İletişim Kurumsal";
        viewAll = "Hepsini gör";
        break;
      case "he": //Hebrew
        categoryTitle = "קטגוריות";
        faqAsk = "נשאל תכופות";
        getInT = "נהיה בקשר";
        contSup = "צור קשר עם תמיכה";
        contCor = "צור קשר עם תאגיד";
        viewAll = "צפה בהכל";
        break;
      case "ar":
        categoryTitle = "فئات";
        faqAsk = "اسئلة متداولة";
        getInT = "ابقى على تواصل";
        contSup = "اتصل بالدعم";
        contCor = "اتصل بالشركة";
        viewAll = "مشاهدة الكل";
        break;
      case "zh": //chinese
        categoryTitle = "类别";
        faqAsk = "常见问题";
        getInT = "保持联系";
        contSup = "联系支持";
        contCor = "联系公司";
        viewAll = "查看全部";
        break;
      case "ro": //romanian
        categoryTitle = "Categorii";
        faqAsk = "Intrebari frecvente";
        getInT = "Contact";
        contSup = "Contactați serviciul pentru clienți";
        contCor = "Contactați compania";
        viewAll = "Vezi totul";
        break;
      case "bg": //bulgarian
        categoryTitle = "Категории";
        faqAsk = "Чести въпроси";
        getInT = "Контакт";
        contSup = "Свържете се с отдела за обслужване на клиенти";
        contCor = "Свържете се с фирмата";
        viewAll = "Вижте всичко";
        break;
      case "uk": //ukrainian
        categoryTitle = "Категорії";
        faqAsk = "Часті питання";
        getInT = "контакт";
        contSup = "Зверніться до служби підтримки клієнтів";
        contCor = "Зверніться до компанії";
        viewAll = "Бачити все";
        break;
      default:
        categoryTitle = "Categories";
        faqAsk = "Frequently asked";
        getInT = "Get in touch";
        contSup = "Contact Support";
        contCor = "Contact Corporate";
        viewAll = "View all";
    }
    return (
      <Layout lang={lang} json={_json}>
        <Seo
          postLanguage={lang}
          postDescription={SiteConfig.seo.siteDescription}
        />
        <section
          className="help-w1110"
          style={{
            margin: "auto",
            padding: "50px 20px 50px 20px",
            backgroundColor: "#fff",
          }}
        >
          <h3 style={{ padding: "10px 33px", fontWeight: "bold" }}>
            {categoryTitle}
          </h3>
          <Row style={{ justifyContent: "center" }}>
            {_json.map((jsonPost) => {
              let categoryMeta;
              if (lang !== "en") {
                categoryMeta = `/${lang}/category/${_.toLower(jsonPost.category)
                  .split(" ")
                  .join("-")}`;
              } else {
                categoryMeta = `/category/${_.toLower(jsonPost.category)
                  .split(" ")
                  .join("-")}`;
              }
              return (
                <Col className="box-category"
                  xs="12"
                  sm="6"
                  md="4"
                  key={`${lang}-${jsonPost.category}`}
                  style={{
                    padding: "30px 60px",
                    maxWidth: "400px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Link className="post-title category" to={categoryMeta}>
                    <div
                      style={{
                        boxShadow: SiteConfig.content.homePage.card.boxShadow,
                        MozBoxShadow:
                          SiteConfig.content.homePage.card.boxShadow,
                        textAlign: "center",
                        height: "85px",
                        borderRadius: "4px",
                        backgroundColor: "#fff",
                        display: "flex",
                        alignContent: "center",
                        justifyContent: "left",
                        borderLeft: "7px solid #1F6BF1",
                      }}
                    >
                      <div
                        style={{
                          paddingBottom: "16px",
                          display: "flex",
                          alignItems: "center",
                          flexDirection: "initial",
                          justifyContent: "center",
                          padding: "16px",
                        }}
                      >
                        <div className="category-post-image">
                          <img
                            src={
                              CategoryIcons[jsonPost.category]
                                ? withPrefix(CategoryIcons[jsonPost.category])
                                : withPrefix("/assets/General.svg")
                            }
                            alt="icon"
                            style={{ width: "34px", height: "34px" }}
                          />
                        </div>
                        <div
                          className="category-title"
                          style={{
                            fontWeight: "bold",
                            textAlign: "left",
                          }}
                        >
                          {`${
                            jsonPost.translatedCategory
                              ? _.replace(
                                  _.replace(
                                    jsonPost.translatedCategory,
                                    /@brand/g,
                                    SiteConfig.brand
                                  ),
                                  "Amp",
                                  "&"
                                )
                              : _.replace(
                                  _.replace(
                                    jsonPost.category,
                                    /@brand/g,
                                    SiteConfig.brand
                                  ),
                                  "Amp",
                                  "&"
                                )
                          }`}
                        </div>
                      </div>
                    </div>
                  </Link>
                </Col>
              );
            })}
          </Row>
        </section>

        <section style={{ background: "#F8F8F8" }}>
          <div
            className="help-w1110"
            style={{ margin: "auto", padding: "20px" }}
          >
            <div className="faqView"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h3 style={{ padding: "10px 33px", fontWeight: "bold" }}>
                {faqAsk}
              </h3>
              <a id="view-all" href="category/features-amp-usability">
                <h5
                  style={{
                    padding: "10px 22px",
                  }}
                >
                  {viewAll}
                  <span style={{ marginLeft: "5px"}}>
                    &#62;
                  </span>
                </h5>
              </a>
            </div>
            <Row style={{ paddingLeft: "0px" }}>
              {_popularTopics &&
                _popularTopics.map((post) => {
                  return (
                    <Col
                      xs="12"
                      sm="6"
                      md="4"
                      key={post.meta}
                      style={{
                        padding: "5px 11px",
                        width: "fit-content",
                      }}
                    >
                      <li
                        className="faq-li-box"
                        style={{
                          marginLeft: "30px",
                          marginRight: "-30px",
                          listStyleType: "none",
                          backgroundColor: "#CFE2FF",
                          height: "38px",
                          display: "flex",
                          alignItems: "center",
                          borderRadius: "10px",
                        }}
                      >
                        <Link
                          className="faq-link"
                          style={{
                            color: "#4E8EFF",
                            padding: "6px 7px",
                            fontSize: "18px",
                            lineHeight: "17px",
                          }}
                          to={post.meta}
                        >
                          {post.title}
                          <span
                            style={{
                              marginLeft: "30px",
                              fontWeight: "bold",
                              fontSize: "22px",
                              fontFamily: "monospace",
                            }}
                          >
                            &#62;
                          </span>
                        </Link>
                      </li>
                    </Col>
                  );
                })}
            </Row>
          </div>
        </section>

        <section
          style={{
            margin: "auto",
            padding: "",
            backgroundColor: "#F8F8F8",
          }}
        >
          <div
            className="help-w1110"
            style={{
              margin: "auto",
              padding: "20px 30px",
            }}
          >
            <h3
              className="get-in-touch"
              style={{ padding: "10px 20px", fontWeight: "bold" }}
            >
              {getInT}
            </h3>
            <Row>
              <Col className="box-contact" xs="12" sm="12" md="4" style={{ padding: "10px 30px" }}>
                <a
                  href="mailto:support@bluemail.me"
                  style={{ color: "#000", textDecoration: "none" }}
                >
                  <div className="resources_c_wrapper">
                    <img
                      src={withPrefix("/assets/ContactSupport.svg")}
                      alt="ContactSupport"
                      style={{
                        width: "28px",
                        marginLeft: "14px",
                        height: "28px",
                      }}
                    />
                    <div style={{ paddingBottom: "16px", padding: "16px" }}>
                      {contSup}
                    </div>
                  </div>
                </a>
              </Col>
              {/* <Col className="box-contact" xs="12" sm="12" md="4" style={{ padding: "10px 30px" }}>
                <a
                  href="mailto:sales@bluemail.me"
                  style={{ color: "#000", textDecoration: "none" }}
                >
                  <div className="resources_c_wrapper">
                    <img
                      src={withPrefix("/assets/ContactCorporate.svg")}
                      alt="ContactCorporate"
                      style={{
                        width: "28px",
                        marginLeft: "14px",
                        height: "28px",
                      }}
                    />
                    <div style={{ paddingBottom: "16px", padding: "16px" }}>
                      {contCor}
                    </div>
                  </div>
                </a>
              </Col> */}
              {/* <Grid item xs={12} sm={6} md={4} style={{ padding: "10px 30px" }}>
              <Link
                to="/device-tips/"
                style={{ color: "#000", textDecoration: "none" }}
              >
                <div
                  className="resources_c_wrapper"
                >
                  <img
                    src={withPrefix("/assets/DeviceTips.svg")}
                    alt="DeviceTips"
                    style={{ width: "28px", marginLeft: '14px' }}
                  />
                  <div style={{ paddingBottom: "16px", padding: '16px' }}>
                    Device Tips
                  </div>
                </div>
              </Link>
            </Grid> */}
            </Row>
          </div>
        </section>
      </Layout>
    );
  }
}

export default TranslatedIndexPage;

export const query = graphql`
  query TranslatedIndexPageQuery {
    site {
      siteMetadata {
        env
      }
    }
  }
`;
